// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolbar {
  padding: 10px;
  padding-left: 10%;
  padding-right: 3%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.toolbar .btn {
  margin: 2px;
}

.toolbar .btn-group {
  display: flex;
  gap: 2px;
}

.choose-layout .btn-group {
  display: flex;
  align-items: center;
}

.choose-layout .layout-label {
  font-weight: 500;
  color: #ddd;
  padding: 5px 10px;
  margin-right: 5px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
  font-size: 14px;
}

.choose-layout .btn-group>button:first-child {
  cursor: default;
  margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/ToolBar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB","sourcesContent":[".toolbar {\n  padding: 10px;\n  padding-left: 10%;\n  padding-right: 3%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.toolbar .btn {\n  margin: 2px;\n}\n\n.toolbar .btn-group {\n  display: flex;\n  gap: 2px;\n}\n\n.choose-layout .btn-group {\n  display: flex;\n  align-items: center;\n}\n\n.choose-layout .layout-label {\n  font-weight: 500;\n  color: #ddd;\n  padding: 5px 10px;\n  margin-right: 5px;\n  background-color: rgba(255, 255, 255, 0.1);\n  border-radius: 3px;\n  font-size: 14px;\n}\n\n.choose-layout .btn-group>button:first-child {\n  cursor: default;\n  margin-right: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
